import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🖼️", key: "visualTransformation" },
  { emoji: "📦", key: "declutterSpace" },
  { emoji: "💸", key: "budgetRefresh" },
  { emoji: "🔨", key: "fullRenovation" },
]

export default function HomeTopPriorityPage() {
  return (
    <RadioCardListPage translationKey="homeTopPriority" options={OPTIONS} />
  )
}
